import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { de } from '../i18n/de';

/**
 * Fußzeile der Startseite, der Anmeldeseiten, der Übersicht, des Profils und der Infoseiten: „Über“ (mit der Version), „Impressum“ und
 * „Datenschutz“. `children` stehen davor (auf der Startseite: Anmelden und Registrieren).
 */
export function SiteFooter({ children }: { children?: ReactNode }) {
  return (
    <footer className="site-foot" data-testid="site-footer">
      <nav className="site-foot-links" aria-label={de.footer.label}>
        {children}
        <Link to="/about" data-testid="foot-about">
          {de.footer.about}
        </Link>
        <Link to="/impressum" data-testid="foot-imprint">
          {de.footer.imprint}
        </Link>
        <Link to="/datenschutz" data-testid="foot-privacy">
          {de.footer.privacy}
        </Link>
      </nav>
    </footer>
  );
}
